import {
  User,
  Properties,
  HackleEvent,
  Decision,
  DecisionReason,
  FeatureFlagDecision,
  HackleRemoteConfig,
  EmptyHackleRemoteConfig,
  PropertyValue
} from "../../../../core/internal/model/model"
import {
  HackleInAppMessageLink,
  HacklePage,
  HackleInAppMessageListener,
  HackleExperiment,
  HackleInAppMessageView
} from "../../../../public/model"
import { PageView } from "../../../index.browser"
import { PropertyOperations } from "../../../property/PropertyOperations"
import { HackleSubscriptionOperations } from "../../../subscription/HackleSubscriptionOperations"
import { InAppMessageBridge } from "./InAppMessageBridge"

export class NoopInAppMessageBridge implements InAppMessageBridge {
  isOptOutTracking(): boolean {
    return false
  }
  setOptOutTracking(optOut: boolean): void {
    return
  }
  openUrl(url: string | HackleInAppMessageLink): void {
    return
  }
  trackClick(elementId?: string | undefined): void {
    return
  }
  handleUrl(url: string | HackleInAppMessageLink, elementId?: string | undefined): void {
    return
  }
  closeInAppMessage(): void {
    return
  }
  close(): void {
    return
  }
  getSessionId(): string {
    return ""
  }
  resetUser(): Promise<void> {
    return Promise.resolve()
  }
  trackPageView(option?: PageView | undefined): void {}
  setCurrentPage(page: HacklePage): void {}
  showUserExplorer(): void {}
  hideUserExplorer(): void {}
  fetch(): Promise<void> {
    return Promise.resolve()
  }
  setInAppMessageListener(listener: HackleInAppMessageListener | null): void {}
  getExperiment(experimentKey: number): HackleExperiment | undefined {
    return undefined
  }
  onReady(block: () => void, timeout?: number | undefined): void {}
  onInitialized(config?: { timeout?: number | undefined } | undefined): Promise<{ success: boolean }> {
    return Promise.resolve({ success: true })
  }
  getUser(): User {
    return {}
  }
  setUser(user: User): Promise<void> {
    return Promise.resolve()
  }
  setUserId(userId: string | number | undefined | null): Promise<void> {
    return Promise.resolve()
  }
  setDeviceId(deviceId: string): Promise<void> {
    return Promise.resolve()
  }
  setUserProperty(key: string, value: any): Promise<void> {
    return Promise.resolve()
  }
  setUserProperties(properties: Properties): Promise<void> {
    return Promise.resolve()
  }
  updateUserProperties(operations: PropertyOperations): Promise<void> {
    return Promise.resolve()
  }
  updatePushSubscriptions(operations: HackleSubscriptionOperations): Promise<void> {
    return Promise.resolve()
  }
  updateSmsSubscriptions(operations: HackleSubscriptionOperations): Promise<void> {
    return Promise.resolve()
  }
  updateKakaoSubscriptions(operations: HackleSubscriptionOperations): Promise<void> {
    return Promise.resolve()
  }
  setPhoneNumber(phoneNumber: string): Promise<void> {
    return Promise.resolve()
  }
  unsetPhoneNumber(): Promise<void> {
    return Promise.resolve()
  }
  track(event: HackleEvent | string, user?: User | string): void {
    return
  }
  getDisplayedInAppMessageView(): HackleInAppMessageView | null {
    return null
  }
  variation(experimentKey: number, user?: User | string, defaultVariation?: string): string {
    return defaultVariation ?? "A"
  }
  variationDetail(experimentKey: number, user?: User | string, defaultVariation?: string): Decision {
    return Decision.of(defaultVariation ?? "A", DecisionReason.UNSUPPORTED_PLATFORM)
  }
  isFeatureOn(featureKey: number, user?: User | string): boolean {
    return false
  }
  featureFlagDetail(featureKey: number, user?: User | string): FeatureFlagDecision {
    return FeatureFlagDecision.off(DecisionReason.UNSUPPORTED_PLATFORM)
  }
  remoteConfig(user?: User | string): HackleRemoteConfig {
    return new EmptyHackleRemoteConfig()
  }
  getTriggerEvent(): HackleEvent | undefined {
    return undefined
  }
  getTriggerEventProperty(
    key: string,
    defaultValue: string | number | boolean | Array<string | number>
  ): PropertyValue {
    return defaultValue
  }
}
